import { MENU_SIDEBAR } from "./menu.config";
import { NavbarMenu } from "./NavbarMenu";

const PageMenu = () => {
    const accountMenuConfig = MENU_SIDEBAR;

    if (accountMenuConfig) {
        return <NavbarMenu items={accountMenuConfig} />;
    } else {
        return null;
    }
};

export { PageMenu };
